import styled, {css} from 'styled-components';
import {Section,BtnFlex,Btn, Container as ContainerStyles, Grid, SectionTitle, SectionSubTitle} from '../ReUsableStyles';
import {Link} from 'react-router-dom';


const InfoTitleName = css`
    display: block;
    text-align: center;
`;

export const AboutSection = styled.section`
    ${Section};
`;
export const Title = styled.h1`
    ${SectionTitle};
`;
export const Subtitle = styled.span`
    ${SectionSubTitle};
`;
export const Container = styled.div`
    ${ContainerStyles};
    ${Grid};
    justify-content:center;
`;
export const Data = styled.div`
    
`;
export const AboutImg = styled.img`
    width:200px;
    border-radius: .5rem;
    justify-self: center;
    align-self: center;
`;
export const Desc = styled.p`
    text-align: center;
    margin-bottom: var(--mb-2-5);
`;
export const Info = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: var(--mb-2-5);
`;
export const InfoTitle = styled.span`
    ${InfoTitleName};
    font-size: var(--h2-font-size);
    font-weight: var(--font-semi-bold);
    color: var(--title-color);
`;

export const InfoName = styled.span`
    ${InfoTitleName};
`;

export const AboutBtns = styled.div`
    display: flex;
    justify-content: center;
`;

export const Button = styled(Link)`
    ${BtnFlex};
    ${Btn};
    &:hover{
        cursor: not-allowed;
        background-color:light-gray;
    }
`;